/**
 * No Op function, a simple helper doing nothing typically used to ignore warnings when a promise is not followed by then or await-ed
 */
export function noop() {

}
